/**
 * Created by 高春超 on 2018/1/23.
 */

const getters = {
  sid: state => state.user.sid,
  name: state => state.user.name,
  memberId: state => state.user.memberId,
  face: state => state.user.face,
  lvname: state => state.user.lvname,
  market: state => state.user.market,
  signed: state => state.user.signed,
  storeId: state => state.user.storeId,
  lucky: state => state.user.lucky,
  isFirstBuy: state => state.user.isFirstBuy
};

export default getters



// WEBPACK FOOTER //
// ./src/components/store/getter.js